import ComponentMixin from '../../../shared/mixins/ComponentMixin';

export default {
    mixins: [
        ComponentMixin,
    ],
    inject: {
        parentValidator: 'parentValidator',
    },
    props: {
        value: {
            type: Object,
            default: () => {
                return {};
            },
        },
        panelCfg: {
            type: Object,
            default: () => {},
        },
        baseTranslateID: {
            type: String,
        },
        vScope: {
            type: String,
            default: 'form',
        },
        readonlyForm: {
            type: Boolean,
            default: true,
        },
        labelDateFormat: {
            type: String,
            default: 'DD/MM/YYYY',
        },
        dateFormat: {
            type: String,
            default: 'YYYY-MM-DD HH:mm:ss',
        },
        lists: {
            type: Object,
            default: () => {
                return {};
            }
        },
    },
    data() {
        return {
            form: this.value,
        }
    },
    created: function() {
        this.$validator = this.parentValidator;
    },
    computed: {
        translateID() {
            return `${this.baseTranslateID}`
        },
        modelTranslateID() {
            return `${this.translateID}.model`
        },
    },
    methods: {
    },
}